module.exports = __webpack_public_path__ + "img/back.487394a5.svg";